export default ['permissionsService', (permissionsService) => {
    const accessService = {};

    accessService.check = input => {
        if (Array.isArray(input)) {
            return input.some(permission => {
                return accessService.matchPermission(permission)
            });
        }

        return accessService.matchPermission(input);
    };

    accessService.matchPermission = permission => {
        switch (permission) {
            case 'admin':
                return permissionsService.user.indexOf('admin') > -1;

            case 'manager':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1;

            case 'only_investor':
                return permissionsService.user.indexOf('investor') > -1;

            case 'only_premier':
                return permissionsService.user.indexOf('premier_admin') > -1;

            case 'investor':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('investor') > -1;

            case 'premier_admin':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('premier_admin') > -1 || permissionsService.user.indexOf('investor') > -1;

            case 'orders':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1 || permissionsService.user.indexOf('orders') > -1;

            case 'stock':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1 || permissionsService.user.indexOf('stock') > -1;

            case 'reporting':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1 || permissionsService.user.indexOf('reporting') > -1;
        }
    }

    return accessService;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/access.service.js